// extracted by css-extract-rspack-plugin
export default {"wrath":"jKKo1p","banner":"m7O5ij","name":"uT_YEP"};